import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationType } from '@shared-libs/enums';
import { AppManager } from '@app/modules/shared/managers/app.manager';
import { NavigationService } from '@shared-services/navigation.service';
import { INavigationRoute } from '@shared-libs/interfaces';
@Component({
	selector: 'navigation-mobile-component',
	templateUrl: 'navigation.mobile.component.html',
	styleUrls: ['./navigation.mobile.component.scss'],
})
export class NavigationMobileComponent {
	@Input() public routes: Array<INavigationRoute>;
	public readonly notInProduction: boolean;

	constructor(
		private readonly appManager: AppManager,
		private readonly navigationService: NavigationService,
		public readonly router: Router
	) {
		this.notInProduction = this.appManager.isNotProduction();
	}

	public async navigateTo(url: string): Promise<void> {
		this.navigationService.resetNavigation();
		await this.navigationService.navigateTo(NavigationType.page, url);
	}

	public isActive(route: string): boolean {
		return this.navigationService.isActive(route);
	}
}
